import { render, staticRenderFns } from "./AdminGymBookingList.vue?vue&type=template&id=02b17554"
import script from "./AdminGymBookingList.vue?vue&type=script&lang=js"
export * from "./AdminGymBookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports